import type { Scene } from "@core/scene-manager";

export interface BloomSceneDeps {
  element: HTMLElement;
  replayButton: HTMLButtonElement;
  menuButton: HTMLButtonElement;
  onReplay: () => Promise<void> | void;
  onMenu: () => Promise<void> | void;
}

/** Финальная bloom-сцена после сбора всех семян. */
export class BloomScene implements Scene {
  readonly id = "bloom" as const;
  private cleanups: (() => void)[] = [];

  constructor(private readonly deps: BloomSceneDeps) {}

  /** Показывает bloom-оверлей с CTA «Play again» и «Main menu». */
  onEnter(): void {
    this.deps.element.classList.add("is-visible");
    this.deps.element.setAttribute("aria-hidden", "false");

    const handleReplay = () => {
      void this.deps.onReplay();
    };
    const handleMenu = () => {
      void this.deps.onMenu();
    };

    this.deps.replayButton.addEventListener("click", handleReplay);
    this.deps.menuButton.addEventListener("click", handleMenu);

    this.cleanups.push(
      () => this.deps.replayButton.removeEventListener("click", handleReplay),
      () => this.deps.menuButton.removeEventListener("click", handleMenu),
    );
  }

  /** Скрывает bloom-оверлей. */
  onExit(): void {
    for (const c of this.cleanups) c();
    this.cleanups = [];
    this.deps.element.classList.remove("is-visible");
    this.deps.element.setAttribute("aria-hidden", "true");
  }
}
